/*
  based on: https://github.com/rzeigler/waveguide/blob/master/src/deferred.ts
 */
import { CompletableImpl } from "./original/support/completable";
import * as T from "./effect";
import { effect } from "./effect";
export class DeferredImpl {
    constructor(r) {
        this.r = r;
        this.c = new CompletableImpl();
        this.wait = T.flatten(T.asyncTotal((callback) => this.c.listen(callback)));
        this.interrupt = T.sync(() => {
            this.c.complete(T.raiseInterrupt);
        });
    }
    done(a) {
        return T.sync(() => {
            this.c.complete(T.pure(a));
        });
    }
    error(e) {
        return T.sync(() => {
            this.c.complete(T.raiseError(e));
        });
    }
    abort(e) {
        return T.sync(() => {
            this.c.complete(T.raiseAbort(e));
        });
    }
    cause(e) {
        return T.sync(() => {
            this.c.complete(T.raised(e));
        });
    }
    complete(exit) {
        return T.sync(() => {
            this.c.complete(T.completed(exit));
        });
    }
    from(source) {
        const completed = effect.chain(T.result(T.provideAll(this.r)(source)), (e) => this.complete(e));
        return T.effect.onInterrupted(completed, this.interrupt);
    }
}
export function makeDeferred() {
    return T.access((r) => new DeferredImpl(r));
}
